import { inject } from '@angular/core';
import { CONFIGURATION } from '../tokens';

export const getConfiguration = () => {
  return inject(CONFIGURATION);
};
